module.exports = __webpack_public_path__ + "img/flag-us.477e59a2.svg";